export default __webpack_public_path__ + "static/media/top-button.33b1dcae.png";